import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";

import useLocales from "../../hooks/useLocales";
import { useSelector } from "react-redux";

const CookiesPreferenceConfirmModal = ({ isOpen, onCancel }) => {
  const { darkMode } = useSelector((state) => state.theme);

  const { translate } = useLocales();

  const [cookies, setCookie] = useCookies(["cookieConsent"]);

  const [selectedCategory, setSelectedCategory] = useState(1);
  const [checkboxState, setCheckboxState] = useState({
    3: false,
    4: false,
    5: false,
  });

  useEffect(() => {
    if (cookies.cookieConsent) {
      setSelectedCategory(cookies.cookieConsent.selectedCategory || 1);
      setCheckboxState({
        3: cookies.cookieConsent.checkboxState3 || false,
        4: cookies.cookieConsent.checkboxState4 || false,
        5: cookies.cookieConsent.checkboxState5 || false,
      });
    }
  }, [cookies]);

  const handleClick = (categoryId) => {
    setSelectedCategory((prevCategory) =>
      prevCategory === categoryId ? prevCategory : categoryId
    );
  };

  const handleCheckboxChange = (categoryId) => {
    setCheckboxState((prevState) => ({
      ...prevState,
      [categoryId]: !prevState[categoryId],
    }));
  };

  const handleSavePreferences = () => {
    onCancel();
    setCookie(
      "cookieConsent",
      {
        selectedCategory,
        checkboxState3: checkboxState[3],
        checkboxState4: checkboxState[4],
        checkboxState5: checkboxState[5],
      },
      {
        path: "/",
        expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
      }
    );
  };

  if (!isOpen) return null;

  const cookieCategories = [
    { id: 1, label: translate("your_privacy") },
    { id: 2, label: translate("strict_necessary_cookies") },
    { id: 3, label: translate("functionality_cookies") },
    { id: 4, label: translate("tracking_cookies") },
    { id: 5, label: translate("targeting_cookies") },
    { id: 6, label: translate("more_info") },
  ];

  const cookieCategoryData = [
    {
      id: 1,
      title: translate("privacy_title"),
      content: translate("privacy_content"),
    },
    {
      id: 2,
      title: translate("strictly_necessary_title"),
      content: translate("strictly_necessary_content"),
    },
    {
      id: 3,
      title: translate("functionality_title"),
      content: translate("functionality_content"),
    },
    {
      id: 4,
      title: translate("tracking_title"),
      content: translate("tracking_content"),
    },
    {
      id: 5,
      title: translate("targeting_advertising_title"),
      content: translate("targeting_advertising_content"),
    },
    {
      id: 6,
      title: translate("more_info_title"),
      content: translate("more_info_content"),
    },
  ];

  const ReadMoreReadLess = ({ text, maxLength }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleReadMoreLess = () => {
      setIsExpanded(!isExpanded);
    };

    const renderText = () => {
      if (text.length <= maxLength) {
        return text;
      }
      if (isExpanded) {
        return (
          <>
            {text}
            <span
              className="text-small2 underline cursor-pointer tracking-[-0.2px] ml-1 mr-1 text-heading_color dark:text-color_v1_dark"
              onClick={toggleReadMoreLess}
            >
            {` ${translate('read_less')}`}
            </span>
          </>
        );
      }
      return (
        <>
          {text.substring(0, maxLength) + "..."}
          <span
            className="text-small2 underline cursor-pointer tracking-[-0.2px] ml-1 mr-1 text-heading_color dark:text-color_v1_dark"
            onClick={toggleReadMoreLess}
          >
          {` ${translate('read_more')}`}
          </span>
        </>
      );
    };

    return (
      <p
        className="text-sm sm:text-base font-normal not-italic tracking-[-0.2px] sm:tracking-[-0.3px]"
        style={{ color: darkMode ? "#D5D5D5" : "#333" }}
      >
        {renderText()}
      </p>
    );
  };

  return (
    <div
      style={{ zIndex: "999999999999" }}
      className="fixed inset-0 h-screen w-screen flex items-center justify-center overflow-y-auto"
    >
      <div
        style={{ zIndex: "999999" }}
        className="absolute h-screen w-screen inset-0 bg-gray-800 opacity-50"
      ></div>
      <div
        style={{ zIndex: "9999999" }}
        className="bg-white dark:bg-dark-primary rounded-lg max-h-screen overflow-y-auto"
      >
        <div className="w-[314px] smm:w-[327px] h-auto sm:w-full p-[24px] lg:p-6">
          <h1 className="font-black dark:text-color_v1_dark	text-lg	tracking-[-0.5px] sm:text-custom_h5 not-italic text-left sm:text-center">
            {translate("cookies_preference_center")}
          </h1>
          <div className="flex-wrap items-center justify-center flex gap-4 mt-4 sm:mt-8">
            <div className="rounded-lg bg-light_bg_v4 dark:bg-dark-secondary w-auto sm:h-[400px] sm:w-[484px] p-4">
              {cookieCategories.map((category) => (
                <div
                  key={category.id}
                  onClick={() => handleClick(category.id)}
                  className={`inline-flex sm:flex items-start gap-2.5 py-[8px] px-[10px] sm:py-[11px] sm:px-[15px] rounded sm:rounded-md w-full cursor-pointer ${
                    selectedCategory === category.id
                      ? darkMode
                        ? "dark:bg-dark-primary"
                        : "bg-white"
                      : ""
                  }`}
                >
                  <p
                    className={`text-xs	sm:text-base	font-bold	not-italic tracking-[-0.2px] sm:tracking-[-0.3px] ${
                      selectedCategory === category.id
                        ? darkMode
                          ? "dark:text-color_v1_dark"
                          : "text-black"
                        : darkMode
                        ? "dark:text-color_v2_dark"
                        : "text-font_light_color"
                    }`}
                  >
                    {category.label}
                  </p>
                </div>
              ))}
            </div>
            <div className="rounded-lg bg-light_bg_v4 dark:bg-dark-secondary w-auto sm:h-[400px] sm:w-[484px] p-4">
              {selectedCategory !== null &&
                cookieCategoryData
                  .filter((data) => data.id === selectedCategory)
                  .map((data) => (
                    <React.Fragment key={data.id}>
                      <div className="inline-flex	 sm:flex items-start	gap-2.5	py-[8px]	px-[10px] sm:py-[11px]	sm:px-[15px] rounded sm:rounded-md w-full">
                        <p className="text-sm dark:text-color_v1_dark	sm:text-xl font-bold	not-italic tracking-[-0.2px] sm:tracking-[-0.5px]">
                          {data.title}
                        </p>
                      </div>
                      <div className="inline-flex	 sm:flex items-start	gap-2.5	py-[8px]	px-[10px] sm:py-[11px]	sm:px-[15px] rounded sm:rounded-md">
                        {window.innerWidth <= 640 ? (
                          <ReadMoreReadLess
                            text={data.content}
                            maxLength={100}
                          />
                        ) : (
                          <p
                            className="text-sm sm:text-base font-normal not-italic tracking-[-0.2px] sm:tracking-[-0.3px]"
                            style={{ color: darkMode ? "#D5D5D5" : "#333" }}
                          >
                            {data.content}
                          </p>
                        )}
                      </div>
                    </React.Fragment>
                  ))}
              {(selectedCategory === 3 ||
                selectedCategory === 4 ||
                selectedCategory === 5) && (
                <div className="flex gap-2 md:gap-[10px] items-center ml-3.5 mr-3.5">
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      id={`checkbox-${selectedCategory}`}
                      checked={checkboxState[selectedCategory]}
                      onChange={() => handleCheckboxChange(selectedCategory)}
                      style={{
                        backgroundColor: checkboxState[selectedCategory]
                          ? "#05B737"
                          : "#e0cec7",
                      }}
                      className="sr-only peer"
                    />
                    <div className="w-[29px] h-[15px] bg-gray-200 dark:bg-[#404040] rounded-full peer peer-checked:after:translate-x-[13.5px] peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[11px] after:w-[11px] after:transition-all peer-checked:bg-green-600"></div>
                  </label>
                  <p className="text-sm sm:text-base font-normal not-italic tracking-[-0.2px] sm:tracking-[-0.3px] text-black dark:text-color_v1_dark">
                    {checkboxState[selectedCategory]
                      ? translate("active")
                      : translate("in_active")}
                  </p>
                </div>
              )}
              {selectedCategory === 2 && (
                <div className="flex gap-2 md:gap-[10px] items-center ml-3.5 mr-3.5">
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={true}
                      onChange={() => {}}
                      style={{ backgroundColor: "#05B737" }}
                      className="sr-only peer"
                    />
                    <div className="w-[29px] h-[15px] bg-gray-200 dark:bg-[#404040] rounded-full peer peer-checked:after:translate-x-[13.5px] peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[11px] after:w-[11px] after:transition-all peer-checked:bg-green-600"></div>
                  </label>
                  <p className="text-sm sm:text-base font-normal not-italic tracking-[-0.2px] sm:tracking-[-0.3px] text-black dark:text-color_v1_dark">
                    {translate("always_active")}
                  </p>
                </div>
              )}
            </div>
          </div>

          <div className="sm:flex sm:pl-6 sm:pr-6 text-center items-center sm:justify-center  mt-6 pl-2 sm:flex-col  min-[1120px]:flex-row min-[1120px]:justify-between">
            <p className="font-normal text-font_light_color text-base sm:text-xl tracking-[-0.3px] sm:tracking-[-0.5px] not-italic mb-2">
              <span
                className="font-normal sm:font-bold text-base sm:text-xl	tracking-[-0.3px] sm:tracking-[-0.5px] not-italic mr-1"
                style={{ color: darkMode ? "#D5D5D5" : "#333" }}
              >
                {translate("cookies_consent")}
              </span>
              {translate("terms_feed")}
            </p>
            <button
              type="submit"
              className="bg-main_color text-white rounded-full h-auto sm:h-14 py-1.5	px-[22px] sm:pt-[13px] sm:pb-[12px] text-small3_b smm:text-small2_b sm:text-small1_bold sm:w-64 w-full"
              onClick={handleSavePreferences}
            >
              {translate("save_my_preferences")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiesPreferenceConfirmModal;
